import isArchived from 'archive/isArchived';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {SchemaSelectorSchema} from 'samples/SchemaSelector';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {OptionValue} from 'ui-library/menus/MenuConstants';
import {SearchableMenuArchivableOptionDatas} from 'ui-library/menus/SearchableMenu';
import {capwords, typeToPluralized} from 'util/NameUtil';

export interface Section {
  title: string;
  value?: OptionValue;
}

/**
 * Returns the SearchableMenu JSON options for schema interfaces
 */
export function getSearchableSchemaInterfaceOptionDatas(
  schemaInterfaces: Array<SchemaSelectorSchema>,
  transformInterface: (schemaInterface: SchemaSelectorSchema) => {},
  options: {optionIcon?: BenchlingIconName} = {}
): SearchableMenuArchivableOptionDatas {
  const interfaceOptionDatas: SearchableMenuArchivableOptionDatas = [];
  interfaceOptionDatas.push({
    name: capwords(typeToPluralized(ModelTypeConstants.SCHEMA_INTERFACE)),
    isHeader: true,
    className: 'schema-section',
  });
  for (let i = 0; i < schemaInterfaces.length; i++) {
    const schemaInterface = schemaInterfaces[i];
    interfaceOptionDatas.push({
      className: 'schema-option',
      name: schemaInterface.name,
      value: transformInterface(schemaInterface),
      extra: {unstarrable: true},
      isArchived: isArchived(schemaInterface),
      icon: options.optionIcon,
    });
  }
  return interfaceOptionDatas;
}
